import { LocalMediaStorage, type Src } from "@vidstack/react";

export class LocalMediaStorageWithoutVolume extends LocalMediaStorage {
  constructor(private readonly storageKey: string) {
    super();
  }

  onChange(src: Src, mediaId: string | null) {
    super.onChange(src, mediaId, this.storageKey);
  }

  async getVolume() {
    return null;
  }

  async setVolume(volume: number) {
    void volume;
  }

  async getMuted() {
    return null;
  }

  async setMuted(muted: boolean) {
    void muted;
  }
}
